import React from "react";

import Button from "../../../UI/Button";

const CommentBox = (props) => {
  const { cancel, error, onInputBlur, onInputChange, placeholder, submit, value } = props;
  const disableSubmit = !value || !value.trim() ? true : false;

  return (
    <div className="ReportsCommentBox w-100">
      <form onSubmit={submit}>
        <label className="ReportsCommentBox__label d-block fs-14 tw:font-bold">
          Provider Comment
        </label>
        <textarea
          className="ReportsCommentBox__textarea w-100 fs-16 fs-bold"
          name="IBARComment"
          onBlur={onInputBlur}
          onChange={onInputChange}
          placeholder={placeholder}
          rows="3"
        />
        {error && <div className="ReportsCommentBox__textarea-error">{error}</div>}
        <div className="d-flex mt-2 justify-content-around justify-content-lg-end">
          <Button className="Btn mx-lg-2 Btn--otl-pri" onClick={cancel}>
            Cancel
          </Button>
          <Button className="Btn mx-lg-2 Btn--pri" disabled={disableSubmit} type="submit">
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CommentBox;
